module.exports = __webpack_public_path__ + "3237d762ebe94b1cc29d46e9d9fdff6e.svg";